<div class="tasks-page">
  <div class="page-header">
    <div>
      <h1>
        <mat-icon>add_task</mat-icon>
        Tasks
      </h1>
      <p class="subtitle">Create and manage project tasks assigned to team leads. Separate from Backlog issues.</p>
    </div>
    <button mat-stroked-button type="button" [disabled]="!selectedProjectId" (click)="openProject()">
      <mat-icon>folder_open</mat-icon>
      Open project
    </button>
  </div>

  @if (error()) {
    <div class="error-banner">
      <mat-icon>error_outline</mat-icon>
      <span>{{ error() }}</span>
      <button mat-icon-button type="button" (click)="error.set(null)"><mat-icon>close</mat-icon></button>
    </div>
  }

  <div class="toolbar">
    <mat-form-field appearance="outline">
      <mat-label>Project</mat-label>
      <mat-select [(ngModel)]="selectedProjectId" (ngModelChange)="onProjectChange()">
        @for (p of projects(); track p.id) {
          <mat-option [value]="p.id">{{ p.name }}{{ p.code ? ' (' + p.code + ')' : '' }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <button mat-raised-button color="primary" type="button" (click)="showCreate = !showCreate">
      <mat-icon>add_task</mat-icon>
      {{ showCreate ? 'Hide form' : 'Add Task' }}
    </button>
    <button mat-stroked-button type="button" [disabled]="!selectedProjectId" (click)="loadTasks()">
      <mat-icon>refresh</mat-icon>
      Refresh
    </button>
    @if (loading() || loadingTasks()) {
      <mat-spinner diameter="28"></mat-spinner>
    }
  </div>

  @if (showCreate) {
    <mat-card class="create-card">
      <mat-card-header>
        <mat-card-title>New project task</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="task-form">
          <mat-form-field appearance="outline" class="full">
            <mat-label>Title *</mat-label>
            <input matInput [(ngModel)]="newTitle" maxlength="300" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="full">
            <mat-label>Description</mat-label>
            <textarea matInput rows="2" [(ngModel)]="newDescription"></textarea>
          </mat-form-field>
          <div class="form-row">
            <mat-form-field appearance="outline">
              <mat-label>Team type</mat-label>
              <mat-select [(ngModel)]="newTeamKind" (ngModelChange)="newTeamLeadId = ''">
                <mat-option value="">Any</mat-option>
                @for (k of teamKindOptions; track k.value) {
                  <mat-option [value]="k.value">{{ k.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Team Lead *</mat-label>
              <mat-select [(ngModel)]="newTeamLeadId">
                @for (l of filteredLeads(); track l.leadEmployeeId) {
                  <mat-option [value]="l.leadEmployeeId">{{ l.leadName }} · {{ l.teamName }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Priority</mat-label>
              <mat-select [(ngModel)]="newPriority">
                @for (p of priorityOptions; track p.value) {
                  <mat-option [value]="p.value">{{ p.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline">
              <mat-label>Start date</mat-label>
              <input matInput type="date" [(ngModel)]="newStartDate" />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Deadline *</mat-label>
              <input matInput type="date" [(ngModel)]="newDueDate" required />
            </mat-form-field>
          </div>
          @if (!teamLeads().length) {
            <p class="hint">No active team leads found. Create a team with a lead under Organization → Teams first.</p>
          }
          <button mat-raised-button color="primary"
            [disabled]="creating() || !selectedProjectId || !newTitle.trim() || !newDueDate || !newTeamLeadId"
            (click)="createTask()">
            {{ creating() ? 'Creating…' : 'Create Task' }}
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  }

  <mat-card class="list-card">
    <mat-card-header>
      <mat-card-title>Tasks for selected project</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      @if (!selectedProjectId) {
        <p class="hint">Select a project to view and add tasks.</p>
      } @else if (!tasks().length && !loadingTasks()) {
        <p class="hint">No tasks yet. Use Add Task above to create the first one.</p>
      } @else {
        <table mat-table [dataSource]="tasks()" class="tasks-table">
          <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef>Title</th>
            <td mat-cell *matCellDef="let row">{{ row.title }}</td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let row">{{ row.statusLabel || row.status }}</td>
          </ng-container>
          <ng-container matColumnDef="priority">
            <th mat-header-cell *matHeaderCellDef>Priority</th>
            <td mat-cell *matCellDef="let row">{{ priorityLabel(row.priority) }}</td>
          </ng-container>
          <ng-container matColumnDef="deadline">
            <th mat-header-cell *matHeaderCellDef>Deadline</th>
            <td mat-cell *matCellDef="let row" [class.overdue]="row.isOverdue">
              {{ row.dueDate ? (row.dueDate | date:'mediumDate') : '—' }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columns"></tr>
          <tr mat-row *matRowDef="let row; columns: columns"></tr>
        </table>
      }
    </mat-card-content>
  </mat-card>
</div>
